import { useSelector } from "react-redux";

import { ComponentCommunityEvent } from "@components";
import { selectAuth } from "@redux";


export const PageCommunityEvent = () => {
    //redux states
    const { userInfo } = useSelector(selectAuth);

    //variable
    const memberTier = userInfo?.memberTier;

    return (
        <ComponentCommunityEvent
            memberTier={memberTier} avatar={""} fullName={""} socials={[]} />
    );
};
